import * as React from 'react';

import {FeatureGatePageWrapper} from './feature-gate-page-wrapper';

export function TerritoriesFeatureGate() {
    return (
        <FeatureGatePageWrapper
            header='Organize and assign leads by geographic regions'
            subHeader='Define territories to ensure leads are matched with the right sales reps, making your team‘s job easier.'
            bullets={[
                'Automatically assign leads based on location, so your sales reps can focus on closing deals.',
                'Keep your team organized with clear regional boundaries, making it simple to manage leads without confusion.',
                'Upgrade for unlimited territories, giving your team the flexibility to tailor their approach in every market you serve.',
            ]}
            feature='territories'
        />
    );
}
